import React from 'react';
import { highlightText } from './highlight-utils';
export var urlify = function (text, highlight) {
    if (!text) {
        return [];
    }
    var urlRegex = /(http:\/\/[^\s]+[^.^!^,^\s]|https:\/\/[^\s]+[^.^!^,^\s]|www.[^\s]+[^.^!^,^\s])/g;
    var textParts = text.split(urlRegex);
    function isUrlPart(i) {
        return i % 2 === 1;
    }
    function urlifyPart(part, i) {
        var href = part.startsWith('www.') ? "http://" + part : part;
        return (React.createElement("a", { key: i, href: href, target: "_blank", rel: "noopener noreferrer" }, highlightText(part, highlight)));
    }
    function urlifyIfNeeded(part, i) {
        return isUrlPart(i) ? urlifyPart(part, i) : part;
    }
    return textParts
        .map(function (part, i) { return urlifyIfNeeded(part, i); })
        .filter(function (elem) { return elem; });
};
//# sourceMappingURL=urlify.js.map